import { RecipientTypeEnum } from "../../../../common/enums/RecipientTypeEnum";
import { AlarmNotificationsType, IAlarmNotificationDetailModel, IAlarmNotificationObjectCountModel } from "../../../../services/alarm-data-service/Models";
import { ActionMenuItem, BaseActions } from "../../../action-menu/ActionMenuItem";
import i18n from "../../../../services/localization-service/i18n";
import { RowDef } from "../../../ag-grid-extensions/models/RowDef";
import { AlarmNotificationEndingReasonEnum } from "../../../../common/enums/AlarmNotificationEndingReasonEnum";
import { ColDef } from "ag-grid-community";
import { getTimeframeTimeDisplayText } from "../../../../common/utilities/TimeframeUtilities";
import { TimeframeTypeEnum } from "../../../../common/enums/TimeframeTypeEnum";

export enum NotificationDetailGridActions  {
    MoreInfo = 'moreinfo'
}

export type NotificationDetailGridActionItem = {
    action: NotificationDetailGridActions | BaseActions | string
} & ActionMenuItem;

export const notificationGridActionItems: NotificationDetailGridActionItem[] = [{
    label: i18n.t("alarmDashboard.moreInfo"),
    //icon: () => <FontAwesomeIcon icon={faSquarePlus} size="1x" />,
    action: NotificationDetailGridActions.MoreInfo,
    order: 0
}];

const projectRow = (
    model: IAlarmNotificationDetailModel,
    ): RowDef => {

    let row: RowDef = {
    };

    row['objectName'] = model.object.displayText;
    row['objectID'] = model.object.id;
    row['objectType'] = model.object.objectType;
    row['active'] = model.object.active;
    row['tags'] = model.tags.map(x => x.displayText as string).join(",");
    row['tagID'] = model.tags[0].id;
    row['setPoint'] = model.setPointName;
    //row['alarmTime'] = format(new Date(model.alarmTimestamp), 'MM/dd/y KK:mm a');
    row['alarmTime'] = model.alarmTimestamp ? getTimeframeTimeDisplayText(TimeframeTypeEnum.None, new Date(model.alarmTimestamp)) : '';
    row['clearTime'] = model.clearTimestamp ? getTimeframeTimeDisplayText(TimeframeTypeEnum.None, new Date(model.clearTimestamp)) : '';
    row['endingReason'] = AlarmNotificationEndingReasonEnum[model.endingReason];
    return row;
};


const NotificationsDetailGridUtils = {


    createGridRows(
        
        notificationDetail: IAlarmNotificationDetailModel[],
        objectCount: IAlarmNotificationObjectCountModel,
        detailType: AlarmNotificationsType,
        filterText: string,
        showText: boolean,
        showEmail: boolean,
        showVoice: boolean,
        ) : RowDef[]  {


            let notificationData: IAlarmNotificationDetailModel[] = [];
    
            if (filterText.trim().length) {
    
                //let target: IAlarmNotificationObjectCountItemModel | undefined;

                const target = objectCount.objectCountItems.find(o => o.eLynxObject.objectName?.toLowerCase() === filterText.toLowerCase() || filterText === '');

                if (target) {

                    if (detailType === AlarmNotificationsType.Objects) {
                        notificationData = notificationDetail.filter(o => o.object.id === target?.eLynxObject.id);
                    } else if (detailType === AlarmNotificationsType.Setpoints) {
                        notificationData = notificationDetail.filter(o => o.setPointID === target?.eLynxObject.id);
                    } else {
                        notificationDetail.forEach((item) => {
                            if (item.recipients.filter(o => o.recipientID === target.eLynxObject.id).length > 0) {
                                notificationData.push(item);
                            }
                        });
    
                    }
                } else {
                    notificationData = notificationDetail;
                }
    
            } else {
                notificationData = notificationDetail;
            }
    
            let data: IAlarmNotificationDetailModel[] = [];


            if (showText && showEmail && showVoice) {
                data = notificationData;
            } else {
                notificationData.forEach((item) => {
                    if (item.recipients.filter(o => (o.recipientType === RecipientTypeEnum.Text && showText) ||
                        (o.recipientType === RecipientTypeEnum.Voice && showVoice) ||
                        (o.recipientType === RecipientTypeEnum.Email && showEmail)).length > 0) {
                        data.push(item);
                    }
                });
            }

            const rows = data.sort((a, b) => new Date(b.alarmTimestamp).getTime() - new Date(a.alarmTimestamp).getTime()).map(o => projectRow(o));

            return rows;
                    
    },
    createGridColumns: function (): ColDef[] {

        let cols: ColDef[] = [{
            headerName: i18n.t("alarmDashboard.object") as string,
            field: "objectName",
            sortable: true,
            //flex: 2,
            editable: false,
            pinned: 'left',
            type: "text, multiline",
            cellStyle: (params) => {
                return {
                    'fontStyle': params?.data?.active ? 'inherit' : 'italic',
                    'textDecoration': 'underline',
                    'cursor': 'pointer'
                };
            },
        }, {
            headerName: i18n.t("objectTypeNames.tags") as string,
            field: "tags",
            sortable: true,
            editable: false,
            //flex: 1
            type: "text, multiline",
            cellStyle: (params) => {
                return {
                    'textDecoration': 'underline',
                    'cursor': 'pointer'
                };
            },

        }, {
            headerName: i18n.t("alarmDashboard.alarmSetpoints") as string,
            field: "setPoint",
            sortable: true,
            editable: false,
            //flex: 1
            type: "text, multiline"
        }, {
            headerName: i18n.t("alarmDashboard.alarmTimestamp") as string,
            field: "alarmTime",
            sortable: true,
            //sort: "desc",
            editable: false,
            //flex: 1
            type: "timestamp, multiline"
        }, {
            headerName: i18n.t("alarmDashboard.clearTimestamp") as string,
            field: "clearTime",
            sortable: true,
            editable: false,
            //flex: 1
            type: "timestamp, multiline"
        }, {
            headerName: i18n.t("alarmDashboard.alarmEndingReason") as string,
            field: "endingReason",
            sortable: true,
            editable: false,
            //flex: 1
            type: "text"
        }];
    
    
        return cols;
    },

}

export default NotificationsDetailGridUtils;